var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6917 5.80833L12.3167 1.43333C12.1917 1.30833 12.0667 1.25 11.875 1.25H4.375C3.68333 1.25 3.125 1.80833 3.125 2.5V17.5C3.125 18.1833 3.68333 18.75 4.375 18.75H10V17.5H4.375V2.5H10.625V6.25C10.625 6.93333 11.1917 7.5 11.875 7.5H15.625V10H16.875V6.25C16.875 6.05833 16.8167 5.93333 16.6917 5.80833ZM11.875 6.25V2.75L15.375 6.25H11.875Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.925L10.8833 14.8083L13.125 12.5667V20H14.375V12.5667L16.6083 14.8083L17.4917 13.925L13.75 10.175L10 13.925Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.b964dcfb2a6ea8b2ae4be09751c0e461.svg";
export { ForwardRef as ReactComponent };